import type { Client, RequestContext } from "../client";
import type { InsightsLicenseCheckResource } from "../resources/insightsLicenseCheckResource";
import type { GetInsightsForReportBffResponse } from "../resources/insightsReportBffResponse";
import type { InsightsReportResource, NewInsightsReportResource } from "../resources/insightsReportResource";
import { BasicRepository } from "./basicRepository";

type InsightsMetricsSplit = "None" | "Project" | "ProjectGroup" | "Environment" | "EnvironmentGroup" | "Tenant" | "TenantTagSet";

export enum InsightsTimeRange {
    LastYear = "LastYear",
    LastQuarter = "LastQuarter",
    LastMonth = "LastMonth",
}

export enum InsightsGranularity {
    Monthly = "Monthly",
    Weekly = "Weekly",
    Daily = "Daily",
}

export class InsightsReportRepository extends BasicRepository<InsightsReportResource, NewInsightsReportResource> {
    constructor(client: Client, requestContext: RequestContext) {
        super("InsightsReports", client, requestContext);
    }

    getInsightsLicenseCheck(): Promise<InsightsLicenseCheckResource> {
        return this.client.get(this.requestContext, "~/bff/insights/reports/license-check");
    }

    async bff(report: InsightsReportResource, split: InsightsMetricsSplit, timeRange: InsightsTimeRange, granularity: InsightsGranularity, tenantTagSetId?: string): Promise<GetInsightsForReportBffResponse> {
        return await this.client.get<GetInsightsForReportBffResponse>(this.requestContext, "~/bff/spaces/{spaceId}/insights/reports/{reportId}{?split,granularity,timeRange,tenantTagSetId}", {
            spaceId: report.SpaceId,
            reportId: report.Id,
            split,
            tenantTagSetId,
            timeRange,
            granularity,
        });
    }

    async requestTrial() {
        return await this.client.post(this.requestContext, "~/bff/insights/request-insights-trial");
    }
}
